'use strict';

import { ProjectElement } from '../../../../../app/resources/element/project-element.interface';
import { Project } from '../../../../../app/resources/project/project.interface';
import { skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ElementComment, ElementLogs } from '../../../../../app/resources/log/logs.interface';

(function() {
  angular
    .module('specsguardApp')
    .controller('widgetProjectCommentsCtrl', widgetProjectCommentsCtrl);

    widgetProjectCommentsCtrl.$inject = ['Labels', 'sg2ProjectService', 'sg2ElementSidebarService', 'sg2ElementService', 'sg2LogService'];

    function widgetProjectCommentsCtrl (Labels, sg2ProjectService, sg2ElementSidebarService, sg2ElementService, sg2LogService) {

      const vm = this;

      /** Labels. */
      vm.LABELS = Labels;

      /** Logs. */
      vm.logs = [];

      /** Log limit. */
      vm.LOG_LIMIT = 25;

      /** Initialize project. */
      vm.project = JSON.parse(JSON.stringify(sg2ProjectService.get()));

      /**
       * Get changes.
       *
       * @todo Remove `$$haskey` property (make copy before ng-repeat).
       * @todo Add interface
       */
      sg2LogService.getLogs().subscribe((logs: ElementLogs) => {
        vm.setLogs(logs.comments);
      });

      /** Add lifecycle hook for unsubscribe. */
      const destroy$ = new Subject();

      /** Subscribe to project updates. */
      sg2ProjectService.project$.pipe(
        skip(1),
        takeUntil(destroy$)
      ).subscribe(p => {
        vm.project = JSON.parse(JSON.stringify(p));
        sg2LogService.getLogs().subscribe((logs: ElementLogs) => {
          vm.setLogs(JSON.parse(JSON.stringify(logs.comments)));
        });
      });

      /** Unsubscribe. */
      vm.$destroy = () => {
        destroy$.next();
        destroy$.complete();
      };

      /**
       * Set comments.
       *
       * @param comments Array of element comments.
       */
      vm.setLogs = (comments: ElementComment[]): void => {
        const logs = [];
        for (const comment of comments) {
          logs.push(comment);
        }
        vm.logs = logs;
      };

      /**
       * Open selected element in sidebar.
       *
       * @param identifier Selected element identifier.
       */
      vm.openSidebar = (comment: ElementComment): void => {
        const element = sg2ElementService.getElement(comment.elementId, { constructionId: comment.constructionId });
        sg2ElementSidebarService.open(element, 'logs');
      };
    }
})();
